// Helper function to convert the date from the db to the format of day - month
// ex: 22-1-2026  -> 22 Jan

const formatDateTag = ( locale?: string, dateString?: string, isYear = false ) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = date.toLocaleString(locale, { month: 'short' });
  if(!isYear) {
    return `${day} ${month}`;
  }
  else {
    const year = date.getFullYear();
    const longMonth = date.toLocaleString(locale, { month: 'long' });
    return `${day} ${longMonth} ${year}`;
  }
};

export default formatDateTag;